import { useUserPreference } from './useUserPreference';

function useHideProjectDetail() {
  const userInfo = JSON.parse(window.localStorage.userInfo || '{}');
  const guid = userInfo?.uid || userInfo?.guid;
  const { value, onChange, isLoading, error } = useUserPreference(
    guid,
    'showDetail',
  );

  return {
    value: typeof value === 'string' && !isLoading ? JSON.parse(value) : false,
    onChange,
    isLoading,
    error,
  };
}

export default useHideProjectDetail;
